const BaseButton: React.FC<{
  id: string;
  className?: string;
  label: string;
  type?: "submit" | "reset" | "button";
  disabled?: boolean;
  onClick?: (e: any) => void;
}> = ({ id, className, label, type, onClick, disabled }) => {
  return (
    <button
      type={type}
      className={"control " + className}
      disabled={disabled || false}
      onClick={type === "button" ? onClick : () => {}}
    >
      {label}
    </button>
  );
};

export default BaseButton;
